export const { VITE_ENV: __ENV__, VITE_REGION: __REGION__ } = import.meta.env;

export const MOCK_ID = 515;

const regionPath = __REGION__? `-checkout-${__REGION__}`: '';

export const BASE_URL = __ENV__ === 'PROD'
  ? `https://acquirer-payment${regionPath}.pingpongx.com`
  : `https://${__ENV__.toLocaleLowerCase()}-acquirer-payment${regionPath}.pingpongx.com`;

export const MERCHANT_API = __ENV__ === 'PROD'
  ? 'https://acquirer-merchant.pingpongx.com'
  : `https://${__ENV__.toLocaleLowerCase()}-acquirer-merchant.pingpongx.com`;
